
import {debounceTime} from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConsumerInteractionService } from '../../services/consumer-interaction.service';
import { ActivatedRoute } from '@angular/router';
import { ConsumerDeviceInteractionModel, PagedConsumerInteractionModel } from '../../models/consumer/consumer-interaction.model';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';


import { ClaimsService } from '../../services/claims.service';
import { DeviceInteractionMultipleModel } from '../../models/consumer/consumer-bulk-interaction.model';

export enum DeviceInteractionType {
    Individual = "individual",
    Multiple = "multiple"
}

@Component({
    selector: 'device-interactions-list',
    templateUrl: './device-interactions-list.component.html',
    styles: []
})


export class DeviceInteractionsListComponent implements OnInit, OnDestroy {

    constructor(private consumerInteractionService: ConsumerInteractionService,
        private route: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private claimsService: ClaimsService) { }

    filterTerm: string;
    inputPlaceholder: string;
    typeList: any[] = [];
    searchTerm: string = "";
    clientId: number;
    consumerId: string;
    subscriptions: any[] = [];
    interactions: ConsumerDeviceInteractionModel[] = [];

    bulkData: DeviceInteractionMultipleModel;
    indivdualData: PagedConsumerInteractionModel;

    pageSize: number = 0;
    page: number = 1;
    totalPages: number = 2;
    selectedType: DeviceInteractionType;
    isSearching: boolean = true;
    totalItems: number;
    inProgressCount: number;
    completedCount: number;
    errorCount: number;
    myInteractionsCount: number;

    bulkCount: number = 0;
    individualCount: number = 0;

    filterList: any[] = [];
    form: UntypedFormGroup;

    ngOnInit() {
        this.inputPlaceholder = "Search by consumer name or consumer address";
        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.subscriptions.push(this.route
            .params
            .subscribe(params => {
                this.consumerId = params['consumerId'];
            }));


        let tab = DeviceInteractionType.Individual;

        if (this.route.snapshot.queryParams) {
            if (this.route.snapshot.queryParams.tab) {
                tab = this.route.snapshot.queryParams.tab as DeviceInteractionType;
            }
        }

        this.createTypeList(tab);

        this.getBulkInteraction(this.page);

        this.form = this.fb.group({
            'searchTerm': ["", Validators.compose([Validators.maxLength(120)])],
        });

        this.subscriptions.push(this.form.controls['searchTerm'].valueChanges.pipe(debounceTime(300)).subscribe(searchResult => {
            this.search(searchResult);
        }));

        this.searchIndividualInteraction(this.page);
    }

    private createTypeList(tab: DeviceInteractionType) {
        this.selectedType = tab;
        this.typeList.push(
            {
                key: "individual",
                label: "Individual",
                count: 0,
                isClicked: this.selectedType == DeviceInteractionType.Individual,
            },
            {
                key: "multiple",
                label: "Multiple",
                count: 0,
                isClicked: this.selectedType == DeviceInteractionType.Multiple,
            }
        )

        this.createFilterList();
    }

    createFilterList() {
        this.filterList = [];
        if (this.selectedType == DeviceInteractionType.Individual) {
            this.inputPlaceholder = "Search by consumer name or consumer address";
            this.filterList.push(
                {
                    key: "all",
                    label: "All",
                    count: this.totalItems,
                    isClicked: true,
                },
                {
                    key: "MyInteractions",
                    label: "My Interactions",
                    count: this.myInteractionsCount,
                    isClicked: false,
                },
                {
                    key: "inprogress",
                    label: "In Progress",
                    count: this.inProgressCount,
                    isClicked: false,
                },
                {
                    key: "completed",
                    label: "Completed",
                    count: this.completedCount,
                    isClicked: false,
                },
                {
                    key: "error",
                    label: "Error",
                    count: this.errorCount,
                    isClicked: false,
                },
            )

        } else {
            this.inputPlaceholder = "Search bulk tag or request type";
            this.filterList.push(
                {
                    key: "All",
                    label: "All",
                    count: 0,
                    isClicked: true,
                },
                {
                    key: "MyInteractions",
                    label: "My Interactions",
                    count: 0,
                    isClicked: false,
                }
            )
        }
    }

    typeListClicked(item: any) {
        this.form.get("searchTerm").setValue("");
        this.filterTerm = "";
        this.searchTerm = "";
        this.page = 1;
        this.form.get("searchTerm").setValue("");
        this.typeList.map(x => x.isClicked = false);
        item.isClicked = true;
        this.selectedType = item.key;
        if (this.selectedType == DeviceInteractionType.Individual) {
            this.searchIndividualInteraction(this.page, this.pageSize, this.searchTerm, this.filterTerm);
        } else {
            this.getBulkInteraction(this.page, this.searchTerm, this.filterTerm);
        }
        this.createFilterList();
    }

    filterButtonClicked(item: any) {
        this.page = 1;
        this.filterList.filter(x => x.isClicked = false);
        item.isClicked = true;
        this.filterTerm = item.label;
        if (this.selectedType == DeviceInteractionType.Individual) {
            this.searchIndividualInteraction(this.page, this.pageSize, this.searchTerm, this.filterTerm);
        } else {
            this.getBulkInteraction(this.page, this.searchTerm, this.filterTerm);
        }
    }

    pageSelected(page: number) {
        this.page = page;
        if (this.selectedType == DeviceInteractionType.Individual) {
            this.searchIndividualInteraction(this.page);
        } else {
            this.getBulkInteraction(this.page);
        }
    }

    searchIndividualInteraction(page?: number, pageSize?: number, searchTerm?: string, filterTerm?: string) {
        this.isSearching = true;
        if (!page) page = 1;
        this.consumerInteractionService.getClientInteractions(this.clientId, page, null, this.searchTerm, this.filterTerm).then((pagedConsumerRes) => {
            this.indivdualData = new PagedConsumerInteractionModel();
            this.indivdualData = pagedConsumerRes;

            this.interactions = pagedConsumerRes.items;
            this.myInteractionsCount = pagedConsumerRes.myInteractionCount;
            this.page = pagedConsumerRes.currentPage;
            this.pageSize = pagedConsumerRes.pageSize
            this.totalPages = pagedConsumerRes.totalPages;
            this.totalItems = pagedConsumerRes.totalItems;
            this.individualCount = pagedConsumerRes.totalItems;
            this.inProgressCount = pagedConsumerRes.inProgressCount;
            this.completedCount = pagedConsumerRes.completedCount;
            this.errorCount = pagedConsumerRes.errorCount;

            this.typeList[0].count = this.individualCount;
            this.typeList[1].count = this.bulkCount;

            if (this.selectedType == DeviceInteractionType.Individual) {
                this.filterList[0].count = pagedConsumerRes.totalItems;
                this.filterList[1].count = pagedConsumerRes.myInteractionCount;
                this.filterList[2].count = pagedConsumerRes.inProgressCount;
                this.filterList[3].count = pagedConsumerRes.completedCount;
                this.filterList[4].count = pagedConsumerRes.errorCount;
            }
        });

        return;
    }

    getBulkInteraction(page?: number, searchTerm?: string, filterTerm?: string) {

        this.searchTerm = searchTerm;
        this.filterTerm = filterTerm;

        if (!page) { this.page = 1; }

        let usedId = this.claimsService.userId;
        this.consumerInteractionService.getBulkClientInteractions(this.clientId, usedId, this.page, null, this.searchTerm, this.filterTerm).then(bulkRes => {
            this.bulkData = new DeviceInteractionMultipleModel();
            this.bulkData = bulkRes;
            this.bulkCount = bulkRes.totalItems;
            this.interactions = bulkRes.items;
            this.myInteractionsCount = bulkRes.myInteractionCount;
            this.page = bulkRes.currentPage;
            this.pageSize = bulkRes.pageSize
            this.totalPages = bulkRes.totalPages;
            this.totalItems = bulkRes.totalItems;
            this.inProgressCount = bulkRes.inProgressCount;
            this.completedCount = bulkRes.completedCount;
            this.errorCount = bulkRes.errorCount;

            this.typeList[0].count = this.individualCount;
            this.typeList[1].count = this.bulkCount;
            if (this.selectedType == DeviceInteractionType.Multiple) {
                this.filterList[0].count = bulkRes.totalItems;
                this.filterList[1].count = bulkRes.myInteractionCount;
            }
        });
    }

    search(searchTerm?: string) {
        this.searchTerm = searchTerm;
        if (!searchTerm) {
            this.searchTerm = this.form.controls['searchTerm'].value;
        }
        if (this.selectedType == DeviceInteractionType.Individual) {
            this.searchIndividualInteraction(this.page, this.pageSize, this.searchTerm, this.filterTerm);
        } else {
            this.getBulkInteraction(this.page, this.searchTerm, this.filterTerm);
        }
    }

    submit(form: UntypedFormGroup) {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
